<template>
  <div class="products pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n
          </v-btn>
          <b>افزودن محصول جدید</b>
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q
          </v-btn>
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">مدیریت محصولات</h4>
        <v-divider
          class="me-10 ms-10 d-none d-sm-none d-md-block"
          vertical
        ></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
            class="mt-5 mt-sm-5 mt-md-0"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle
              </v-icon>
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-tabs v-model="tab" :vertical="deviceType == 'mobile'">
        <v-tab
          @click="
            filter = '';
            currentPage = 1;
            perPage = 10;
          "
        >
          انبارداری
        </v-tab>
        <v-tab
          v-show="roleName != 'sales'"
          @click="
            submit();
            filter = '';
            currentPage = 1;
            perPage = 10;
          "
        >
          رسید و حواله
        </v-tab>
        <!-- <v-tab @click="expireTabFunc()" v-show="roleName != 'sales'">
          محصولات درحال انقضا
        </v-tab> -->
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <v-card v-if="loading" flat>
            <div class="d-flex flex-column align-items-center mt-8 py-6">
              <atom-spinner
                :animation-duration="1000"
                :size="80"
                :color="'#6200ea'"
              />
              <p class="primary--text font-weight-bold mt-4">
                در حال بارگذاری اطلاعات...
              </p>
            </div>
          </v-card>
          <v-card v-else flat>
            <v-container class="pt-12">
              <v-row>
                <v-col class="d-flex flex-row">
                  <h4 class="primary--text">انبارداری فروشگاه</h4>
                  <span style="padding-top: 2px" class="c-grey ms-4"
                    >({{ Number(products.length).toLocaleString() }} کالا)</span
                  >
                </v-col>
                <v-col class="text-sm-left">
                  <v-btn
                    v-if="roleName != 'sales'"
                    @click="openNewProduct()"
                    @shortkey="openNewProduct()"
                    v-shortkey.once="['n']"
                    class="purple-borderedBtn"
                    height="43"
                  >
                    <v-icon class="me-1">$Bag</v-icon>
                    افزودن محصول جدید
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="c-grey d-flex flex-sm-row flex-column">
                  <div class="me-4 mt-2 mb-sm-0 mb-4 font-weight-bold">
                    مرتب ‌سازی براساس:
                  </div>
                  <div
                    v-for="(item, index) in sortOptions"
                    :key="index"
                    class="sort-box me-1 pointer"
                    @click="selectedSort = item"
                    :class="selectedSort == item ? 'selected-sort' : ''"
                  >
                    {{ item }}
                  </div>
                </v-col>
              </v-row>

              <hr />
              <vue-excel-xlsx
                v-if="computedItems.length"
                :data="computedItems"
                style="float: left"
                class="darkGreen-mainBtn white--text py-2 px-6 mx-2 mb-6"
                :columns="excelFields"
                :filename="'انبارداری فروشگاه '"
                sheetname="انبارداری فروشگاه"
              >
                <v-icon class="white--text">mdi-file-excel</v-icon>
                دریافت اکسل
              </vue-excel-xlsx>
              <div
                class="d-flex flex-column align-items-center mt-8 py-6"
                v-if="!loaded1"
              >
                <atom-spinner
                  :animation-duration="1000"
                  :size="80"
                  :color="'#6200ea'"
                />
                <p class="primary--text font-weight-bold mt-4">
                  در حال بارگذاری اطلاعات...
                </p>
              </div>
              <div class="custom-table mt-3 pa-3" v-else>
                <b-table
                  responsive
                  show-empty
                  :current-page="currentPage"
                  :per-page="perPage"
                  :items="computedItems"
                  :fields="productsFields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد."
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                  class="pe-5"
                >
                  <template v-slot:empty>
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      رکوردی برای نمایش وجود ندارد.
                    </div>
                  </template>
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:head(name)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        max-width: 200px;
                      "
                    >
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>
                  <template v-slot:cell(available)="data">
                    <div style="text-align: right; vertical-align: middle">
                      <div v-if="data.item.sum == 0" class="red-badge mx-auto">
                        اتمام موجودی
                      </div>
                      <div v-else class="green-badge mx-auto">موجود</div>
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        min-width: 100px;
                        max-width: 200px;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div v-if="data.item.price > 0">
                      {{ Number(data.item.price).toLocaleString() }} تومان
                    </div>
                    <div v-else>بدون قیمت</div>
                  </template>
                  <template v-slot:cell(onlineName)="data">
                    <div
                      style="
                        text-align: right;
                        vertical-align: middle;
                        min-width: 100px;
                        max-width: 150px;
                      "
                    >
                      {{ data.value ? data.value : "-" }}
                    </div>
                  </template>
                  <template v-slot:cell(variants)="data">
                    <div
                      style="
                        text-align: right;
                        vertical-align: middle;
                        min-width: 200px;
                        max-width: 300px;
                      "
                    >
                      {{ data.value.length }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="row">
                    <div
                      v-show="roleName != 'sales'"
                      style="text-align: right; vertical-align: middle"
                      class="pt-0 btn-single-panel"
                    >
                      <v-btn
                        class="orange-mainBtn"
                        width="auto"
                        height="40"
                        @click="goToId(row.item)"
                      >
                        <v-icon class="me-1">mdi-pencil-box-outline </v-icon>
                        ویرایش
                      </v-btn>
                    </div>
                    <div v-show="roleName == 'sales'">--</div>
                  </template>
                  <template v-slot:cell(variantsBarcodes)="data">
                    <div
                      v-if="data.value.length > 20"
                      style="text-align: center; vertical-align: middle"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attr }">
                          <span v-on="on" v-bind="attr">
                            {{ data.value.slice(0, 20) }} </span
                          ><span>...</span>
                        </template>
                        <div>
                          <span>
                            {{ data.value ? data.value : "-" }}
                          </span>
                        </div>
                      </v-tooltip>
                    </div>
                    <div
                      v-else
                      style="text-align: center; vertical-align: middle"
                    >
                      {{ data.value ? data.value : "-" }}
                    </div>
                  </template>
                  <template v-slot:cell(variantsPriceRange)="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.value ? data.value : "-" }}
                    </div>
                  </template>
                </b-table>
                <v-row class="mt-6">
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage"
                        type="number"
                        @change="goToPage(whichPage)"
                        @click="goToPage(whichPage)"
                        :items="computedIndex"
                        color="shopPrimary"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="text-sm-left text-center">
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedItems.length / perPage)"
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        class="float-sm-end"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-container class="pt-12">
            <v-card v-if="loading2" flat>
              <div class="d-flex flex-column align-items-center mt-8 py-6">
                <atom-spinner
                  :animation-duration="1000"
                  :size="80"
                  :color="'#6200ea'"
                />
                <p class="primary--text font-weight-bold mt-4">
                  در حال بارگذاری اطلاعات...
                </p>
              </div>
            </v-card>
            <v-card v-else flat>
              <v-row>
                <v-col class="d-flex flex-row flex-wrap">
                  <h4 class="primary--text">رسید و حواله فروشگاه</h4>
                  <span style="padding-top: 2px" class="c-grey ms-4"
                    >({{ allExchanges.length }} عدد)</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="c-grey d-flex flex-row flex-wrap">
                  <div class="customSelect2 me-4 pb-0 mb-4 mb-md-0">
                    <span class="shopPrimary--text pt-3 pe-2"> فیلتر نوع </span>
                    <v-select
                      dense
                      outlined
                      hide-details
                      :items="types"
                      v-model="typeFilter"
                      @change="currentPage = 1"
                    >
                      <template v-slot:append>
                        <v-icon class="shopPrimary--text">$ArrowDown</v-icon>
                      </template>
                    </v-select>
                  </div>
                  <MyCalendar
                    @submit="submit()"
                    @getStartDate="getStartDate"
                    @getEndDate="getEndDate"
                    :label="'فیلتر زمانی'"
                    :icon="'arrow'"
                    :start="startDate"
                    :end="endDate"
                  />
                </v-col>
              </v-row>
              <hr />

              <div class="custom-table mt-3">
                <b-table
                  responsive
                  show-empty
                  :current-page="currentPage"
                  :per-page="perPage"
                  :items="computedExchanges"
                  :fields="exchangesFields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد."
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                >
                  <template v-slot:empty>
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      رکوردی برای نمایش وجود ندارد.
                    </div>
                  </template>

                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:head(name)="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>
                  <template v-slot:cell(type)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <div
                        class="mx-auto"
                        :class="
                          data.value == 'رسید' ? 'green-badge' : 'red-badge'
                        "
                      >
                        {{ data.value }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(sum)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <div
                        v-if="Number(data.value) == 0"
                        class="red-badge mx-auto"
                      >
                        اتمام موجودی
                      </div>
                      <div v-else>{{ data.value }}</div>
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: right;
                        vertical-align: middle;
                        min-width: 100px;
                        max-width: 150px;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(warehouseItemName)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        min-width: 180px;
                        max-width: 200px;
                      "
                    >
                      {{
                        data.value +
                        (data.item.warehouseItemIdColor
                          ? " / رنگ: " + data.item.warehouseItemIdColor
                          : "") +
                        (data.item.warehouseItemIdSize
                          ? " / سایز: " + data.item.warehouseItemIdSize
                          : "") +
                        (data.item.warehouseItemIdVolume
                          ? " / حجم :" + data.item.warehouseItemIdVolume
                          : "") +
                        (data.item.warehouseItemIdVolume
                          ? " / ابعاد: " + data.item.warehouseItemIdVolume
                          : "") +
                        (data.item.warehouseItemIdWeight
                          ? " / وزن: " + data.item.warehouseItemIdWeight
                          : "") +
                        (data.item.warehouseItemIdProducingCountry
                          ? " / کشور تولید کننده: " +
                            data.item.warehouseItemIdProducingCountry
                          : "") +
                        (data.item.warehouseItemIdProductionYear
                          ? " / سال تولید: " +
                            data.item.warehouseItemIdProductionYear
                          : "") +
                        (data.item.warehouseItemIdContents
                          ? " / ترکیبات: " + data.item.warehouseItemIdContents
                          : "")
                      }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>

                  <template v-slot:cell(operation)="row">
                    <div
                      style="text-align: right; vertical-align: middle"
                      class="pt-0"
                    >
                      <v-btn
                        v-if="!row.item._showDetails"
                        @click="row.toggleDetails"
                        class="orange-mainBtn"
                        width="120"
                        >نمایش عملیات
                      </v-btn>
                      <v-btn
                        v-else
                        @click="row.toggleDetails"
                        class="red-mainBtn"
                        width="120"
                        >بستن عملیات
                      </v-btn>
                    </div>
                  </template>
                  <template #row-details="row">
                    <div
                      class="animated fadeIn mb-2"
                      style="text-align: center; vertical-align: middle"
                    >
                      <v-btn
                        class="orange-mainBtn mx-2"
                        width="95"
                        height="40"
                        @click="openDialog(row.item, 'edit')"
                      >
                        <v-icon class="me-1">mdi-pencil-box-outline </v-icon>
                        ویرایش
                      </v-btn>
                      <v-btn
                        class="green-mainBtn mx-2"
                        width="155"
                        height="40"
                        @click="openDialog(row.item, 'increase')"
                      >
                        <v-icon class="me-1">mdi-plus-box-outline </v-icon>
                        افزایش موجودی
                      </v-btn>
                      <v-btn
                        class="yellow-mainBtn mx-2"
                        width="155"
                        height="40"
                        @click="openDialog(row.item, 'decrease')"
                        :disabled="!Number(row.item.sum)"
                      >
                        <v-icon class="me-1">mdi-minus-box-outline</v-icon>
                        کاهش موجودی
                      </v-btn>
                    </div>
                  </template>
                </b-table>
                <v-row class="mt-6">
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage1"
                        :items="computedExchangesIndex"
                        @change="goToPage(whichPage1)"
                        @click="goToPage(whichPage1)"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="text-sm-left text-center">
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedExchanges.length / perPage)"
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        class="float-sm-end"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-container>
        </v-tab-item>
        <!-- <v-tab-item>
          <v-container class="pt-12">
            <v-card flat>
              <v-row>
                <v-col class="d-flex flex-row">
                  <h4 class="primary--text">محصولات درحال انقضا</h4>
                  <span style="padding-top: 2px" class="c-grey ms-4"
                    >({{ expireProducts.length }} محصول)</span
                  >
                </v-col>
              </v-row>
              <v-row class="custom-input">
                <v-col class="d-flex flex-wrap flex-column flex-md-row">
                  <div>
                    <div id="startExpireDate">
                      <v-text-field
                        placeholder="تاریخ شروع"
                        outlined
                        dense
                        hide-details
                        append-icon="mdi-calendar"
                        v-model="startExpireDate"
                        :disabled="chosenType == 'expired'"
                        class="date-input me-0 me-md-2"
                      ></v-text-field>
                    </div>
                    <date-picker
                      element="startExpireDate"
                      v-model="startExpireDate"
                      type="date"
                      color="#EF6C00"
                      :disabled="chosenType == 'expired'"
                    ></date-picker>
                  </div>
                  <div class="ms-0 my-3 my-md-0">
                    <span id="endExpireDate">
                      <v-text-field
                        placeholder="تاریخ پایان"
                        outlined
                        dense
                        hide-details
                        append-icon="mdi-calendar"
                        v-model="endExpireDate"
                        class="date-input me-0 me-md-2"
                        :disabled="chosenType == 'expired'"
                      ></v-text-field>
                    </span>
                    <date-picker
                      element="endExpireDate"
                      v-model="endExpireDate"
                      type="date"
                      color="#EF6C00"
                      :disabled="chosenType == 'expired'"
                    ></date-picker>
                  </div>
                  <v-btn
                    height="42"
                    style="width: 100px !important"
                    class="orange-mainBtn"
                    :disabled="!endExpireDate || !startExpireDate"
                    @click="getExpireProducts()"
                    >اعمال</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <div class="d-flex flex-wrap">
                    <v-btn
                      v-for="item in dateTypes"
                      :key="item.value"
                      class="ma-1"
                      :class="
                        chosenType == item.value
                          ? 'orange-mainBtn'
                          : 'orange-borderedBtn'
                      "
                      @click="chooseDateType(item)"
                    >
                      {{ item.text }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <hr />
              <div
                v-if="productsLoading"
                class="d-flex flex-column align-items-center mt-8 py-6"
              >
                <atom-spinner
                  :animation-duration="1000"
                  :size="80"
                  :color="'#EF6C00'"
                />
                <p class="primary--text font-weight-bold mt-4">
                  در حال بارگذاری اطلاعات...
                </p>
              </div>
              <div v-else class="custom-table mt-3">
                <b-table
                  responsive
                  show-empty
                  :current-page="currentPage"
                  :per-page="perPage"
                  :items="computedExpiredProducts"
                  :fields="expireFields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد."
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                >
                  <template v-slot:empty>
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      رکوردی برای نمایش وجود ندارد.
                    </div>
                  </template>
                  <template v-slot:head()="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>

                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: right;
                        vertical-align: middle;
                        min-width: 100px;
                        max-width: 150px;
                      "
                    >
                      {{
                        data.value +
                        (data.item.color ? " / رنگ: " + data.item.color : "") +
                        (data.item.size ? " / سایز: " + data.item.size : "") +
                        (data.item.volume
                          ? " / حجم :" + data.item.volume
                          : "") +
                        (data.item.dimension
                          ? " / ابعاد: " + data.item.dimension
                          : "") +
                        (data.item.weight
                          ? " / وزن: " + data.item.weight
                          : "") +
                        (data.item.producingCountry
                          ? " / محصول کشور: " + data.item.producingCountry
                          : "") +
                        (data.item.productionYear
                          ? " / سال تولید: " + data.item.productionYear
                          : "") +
                        (data.item.contents
                          ? " / ترکیبات: " + data.item.contents
                          : "")
                      }}
                    </div>
                  </template>
                </b-table>
                <v-row class="mt-6">
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage2"
                        type="number"
                        @change="goToPage(whichPage2)"
                        @click="goToPage(whichPage2)"
                        :items="computedExpiredIndex"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="text-sm-left text-center">
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        :length="
                          Math.ceil(computedExpiredProducts.length / perPage)
                        "
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        class="float-sm-end"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-container>
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>
    <v-dialog v-model="newProductDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت محصول جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newProductDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input pb-0">
          <v-row>
            <v-col>
              <div class="d-flex align-items-end mb-6">
                <div
                  class="img-box pointer"
                  @click="$refs.productImage.$refs.input.click()"
                >
                  <img
                    height="150"
                    width="150"
                    class="img"
                    :src="
                      newItem.pictureId ? newItem.pictureUrl : '/no-image.png'
                    "
                  />
                  <v-icon x-large class="img-icon white--text"
                    >mdi-camera
                  </v-icon>
                  <div class="img-loading" v-if="mainImageLoading">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      :size="40"
                    ></v-progress-circular>
                    <h6 class="mt-4 grey--text text--darken-4">
                      در حال بارگذاری...
                    </h6>
                  </div>
                </div>
                <v-btn
                  class="orange-mainBtn pa-5 ms-4"
                  @click="$refs.productImage.$refs.input.click()"
                >
                  <v-icon class="me-2">mdi-camera-outline</v-icon>
                  بارگذاری تصویر برگزیده
                </v-btn>
                <v-file-input
                  v-show="false"
                  @change="newProductMainImageUpload(mainImage)"
                  v-model="mainImage"
                  ref="productImage"
                ></v-file-input>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام محصول:</label
              >
              <v-text-field
                placeholder="نام محصول"
                outlined
                dense
                hide-details
                v-model="newItem.name"
                :disabled="role == 'sales'"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"
                >نام فروشگاهی:</label
              >
              <v-text-field
                placeholder="نام فروشگاهی"
                outlined
                dense
                hide-details
                v-model="newItem.onlineName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت خرید (تومان):</label
              >
              <v-text-field
                placeholder="قیمت خرید (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="newItem.buyPrice"
              ></v-text-field>
              <span class="ps-2 pt-4"
                >{{
                  newItem.buyPrice
                    ? Number(newItem.buyPrice / 10).toLocaleString() + " تومان "
                    : ""
                }}
              </span>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت فروش (تومان):</label
              >
              <v-text-field
                placeholder="قیمت فروش (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="newItem.price"
              ></v-text-field>
              <span class="ps-2 pt-4"
                >{{
                  newItem.price
                    ? Number(newItem.price / 10).toLocaleString() + " تومان "
                    : ""
                }}
              </span>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col class="pt-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text"></span> تاریخ اعتبار:</label
              >
              <span id="expireDate">
                <v-text-field
                  placeholder="تاریخ اعتبار"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="newItem.expireDate"
                ></v-text-field>
              </span>
              <date-picker
                element="expireDate"
                v-model="newItem.expireDate"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> تعداد اولیه:</label
              >
              <v-text-field
                placeholder="تعداد اولیه"
                outlined
                dense
                hide-details
                type="number"
                v-model="newItem.amount"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">بارکد:</label>
              <v-text-field
                placeholder="بارکد"
                outlined
                dense
                v-model="newItem.barcode"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0 d-flex align-items-center">
              <v-checkbox
                v-model="newItem.special"
                color="primary"
                hide-details
              >
                <template v-slot:label>
                  <span class="mb-2">این محصول ویژه است.</span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> دسته‌بندی: </label>

              <v-select
                dense
                outlined
                hide-details
                placeholder="دسته‌بندی"
                :items="categories"
                v-model="newItem.categoryId"
                item-value="id"
                item-text="name"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"
                >برچسب‌های محصول:</label
              >
              <div class="d-flex flex-row">
                <v-text-field
                  outlined
                  dense
                  height="40"
                  hide-details
                  v-model="newTag"
                  @keyup.enter="newTag ? addNewTag('newItem') : ''"
                  >''
                  <template slot="label">
                    <div style="font-size: 14px">برچسب‌ جدید</div>
                  </template>
                </v-text-field>
                <v-btn
                  class="ms-2 green-mainBtn"
                  width="60"
                  min-width="40"
                  height="40"
                  :disabled="!newTag"
                  @click="addNewTag('newItem')"
                  >ثبت
                </v-btn>
              </div>
              <div v-if="newItem.tags">
                <v-row v-if="newItem.tags.length">
                  <v-col class="d-flex flex-wrap">
                    <div
                      class="orange-badge me-2 mb-2"
                      v-for="(item, index) in newItem.tags"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                      <span
                        ><v-icon
                          @click="removeTag('newItem', index)"
                          color="primary"
                          small
                          class="ps-1"
                          >mdi-close</v-icon
                        ></span
                      >
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> برند: </label>

              <v-select
                dense
                outlined
                hide-details
                placeholder="برند"
                :items="brands"
                v-model="newItem.brandId"
                item-value="id"
                item-text="name"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <!--<v-row>
            <v-col>
              <label class="primary--text font-weight-bold"
                >افزودن تصویر به گالری محصول:</label
              >
              <v-file-input
                outlined
                dense
                @change="newProductGalleryUpload(galleryImage)"
                v-model="galleryImage"
                prepend-inner-icon="mdi-image-outline"
                prepend-icon=""
                class="file-input"
                label="بارگذاری تصویر"
              >
              </v-file-input>
              <v-progress-linear
                rounded
                v-if="myFile.showProgress"
                height="10"
                :value="myFile.uploadPercentage"
                class="mb-4 mt-0"
              >
              </v-progress-linear>
              <v-row>
                <div
                  v-if="myFile.isUploaded"
                  color="green"
                  class="mb-1 pa-3"
                  style="font-size: 16px"
                >
                  فایل با موفقیت بارگذاری شد.
                </div>
              </v-row>
              <div
                v-if="newProductGallery.length"
                class="files-box d-flex flex-column"
              >
                <div class="files-title">
                  لیست تصاویر محصول ({{ newProductGallery.length }})
                </div>
                <span
                  v-for="(item, index) in newProductGallery"
                  :key="index"
                  class="mb-2 pt-2"
                >
                  <span @click="deleteFile(index)" class="pointer">
                    <v-icon class="red--text text--lighten-1 pe-2"
                      >mdi-close-circle-outline</v-icon
                    >
                  </span>
                  <a :href="item.url" target="blank">{{
                    newFileNames[index]
                  }}</a>
                </span>
              </div>
            </v-col>
          </v-row>-->
          <v-row>
            <v-col>
              <label class="primary--text font-weight-bold"
                >توضیحات محصول:</label
              >
              <v-textarea
                dense
                outlined
                hide-details
                label="توضیحات"
                rows="3"
                v-model="newItem.description"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label class="primary--text font-weight-bold"
                >توضیحات آنلاین‌ شاپ:</label
              >
              <v-textarea
                dense
                outlined
                hide-details
                label="توضیحات"
                rows="3"
                v-model="newItem.onlineShopDescription"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left pb-3 px-4 mt-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="newProductDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addItem()"
            :disabled="busy || computedNewBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ویرایش اطلاعات محصول</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="editDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input pb-0">
          <v-row>
            <v-col>
              <div class="d-flex align-items-end mb-6">
                <div
                  class="img-box pointer"
                  @click="$refs.editProductImage.$refs.input.click()"
                >
                  <img
                    height="150"
                    width="150"
                    class="img"
                    :src="
                      selectedItem.pictureId
                        ? selectedItem.pictureUrl
                        : '/no-image.png'
                    "
                  />
                  <v-icon x-large class="img-icon white--text"
                    >mdi-camera
                  </v-icon>
                  <div class="img-loading" v-if="editMainImageLoading">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      :size="40"
                    ></v-progress-circular>
                    <h6 class="mt-4 grey--text text--darken-4">
                      در حال بارگذاری...
                    </h6>
                  </div>
                </div>
                <v-btn
                  class="orange-mainBtn pa-5 ms-4"
                  @click="$refs.editProductImage.$refs.input.click()"
                >
                  <v-icon class="me-2">mdi-camera-outline</v-icon>
                  بارگذاری تصویر برگزیده
                </v-btn>
                <v-file-input
                  v-show="false"
                  @change="editProductMainImageUpload(editMainImage)"
                  v-model="editMainImage"
                  ref="editProductImage"
                ></v-file-input>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام محصول:</label
              >
              <v-text-field
                placeholder="نام محصول"
                outlined
                dense
                v-model="selectedItem.name"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"
                >نام فروشگاهی:</label
              >
              <v-text-field
                placeholder="نام فروشگاهی"
                outlined
                dense
                hide-details
                v-model="selectedItem.onlineName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">بارکد:</label>
              <v-text-field
                placeholder="بارکد"
                outlined
                dense
                v-model="selectedItem.barcode"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت فروش (تومان):</label
              >
              <v-text-field
                placeholder="قیمت فروش (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.price"
              ></v-text-field>
              <span class="ps-2 pt-4"
                >{{
                  Number(selectedItem.price / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت خرید (تومان):</label
              >
              <v-text-field
                placeholder="قیمت خرید (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.buyPrice"
              ></v-text-field>
              <span v-if="selectedItem.buyPrice" class="ps-2 pt-4"
                >{{
                  Number(selectedItem.buyPrice / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"
                >تاریخ اعتبار:</label
              >
              <span id="expireDateEdit">
                <v-text-field
                  placeholder="تاریخ اعتبار"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedItem.expireDate"
                ></v-text-field>
              </span>
              <date-picker
                element="expireDateEdit"
                v-model="selectedItem.expireDate"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0 d-flex align-items-center">
              <v-checkbox
                v-model="selectedItem.special"
                color="primary"
                hide-details
              >
                <template v-slot:label>
                  <span class="mb-2">این محصول ویژه است.</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> دسته‌بندی: </label>

              <v-select
                dense
                outlined
                hide-details
                placeholder="دسته‌بندی"
                :items="categories"
                v-model="selectedItem.categoryId"
                item-value="id"
                item-text="name"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> برند: </label>

              <v-select
                dense
                outlined
                hide-details
                placeholder="برند"
                :items="brands"
                v-model="selectedItem.brandId"
                item-text="name"
                item-value="id"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label class="primary--text font-weight-bold"
                >برچسب‌های محصول:</label
              >
              <div class="d-flex flex-row">
                <v-text-field
                  outlined
                  dense
                  height="40"
                  class="mt-1"
                  hide-details
                  v-model="editNewTag"
                  @keyup.enter="editNewTag ? addNewTag('selectedItem') : ''"
                >
                  <template slot="label">
                    <div style="font-size: 14px">برچسب‌ جدید</div>
                  </template>
                </v-text-field>
                <v-btn
                  class="ms-2 mt-1 green-mainBtn"
                  width="60"
                  min-width="40"
                  height="40"
                  :disabled="!editNewTag"
                  @click="addNewTag('selectedItem')"
                  >ثبت
                </v-btn>
              </div>
              <div v-if="selectedItem.tags">
                <v-row v-if="selectedItem.tags.length">
                  <v-col class="d-flex flex-wrap">
                    <span v-show="false">{{ reactivity }}</span>
                    <div
                      class="orange-badge me-2 mb-2"
                      v-for="(item, index) in selectedItem.tags"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                      <span
                        ><v-icon
                          @click="removeTag('selectedItem', index)"
                          color="primary"
                          small
                          class="ps-1"
                          >mdi-close</v-icon
                        ></span
                      >
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label class="primary--text font-weight-bold"
                >افزودن تصویر به گالری محصول:</label
              >
              <v-file-input
                outlined
                dense
                @change="editProductGalleryUpload(galleryImage)"
                v-model="galleryImage"
                prepend-inner-icon="mdi-image-outline"
                prepend-icon=""
                class="file-input"
                label="بارگذاری تصویر"
              >
              </v-file-input>
              <v-progress-linear
                rounded
                v-if="myFile.showProgress"
                height="10"
                :value="myFile.uploadPercentage"
                class="mb-4 mt-0"
              >
              </v-progress-linear>
              <v-row>
                <div
                  v-if="myFile.isUploaded"
                  color="green"
                  class="mb-1 pa-3"
                  style="font-size: 16px"
                >
                  فایل با موفقیت بارگذاری شد.
                </div>
              </v-row>
              <div
                v-if="selectedItem.gallery && selectedItem.gallery.length"
                class="files-box d-flex flex-column"
              >
                <div class="files-title">
                  لیست تصاویر محصول ({{ selectedItem.gallery.length }})
                </div>
                <span
                  v-for="(item, index) in selectedItem.gallery"
                  :key="index"
                  class="mb-2 pt-2"
                >
                  <span @click="deleteFile(index)" class="pointer">
                    <v-icon class="red--text text--lighten-1 pe-2"
                      >mdi-close-circle-outline</v-icon
                    >
                  </span>
                  <a :href="item.url" target="blank">{{ item.name }}</a>
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold pt-2"
                >توضیحات محصول:</label
              >
              <v-textarea
                outlined
                dense
                rows="3"
                hide-details
                v-model="selectedItem.description"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold pt-2"
                >توضیحات آنلاین شاپ:</label
              >
              <v-textarea
                outlined
                dense
                rows="3"
                v-model="selectedItem.onlineShopDescription"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left pb-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="editDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="editItem()"
            :disabled="busy || computedEditBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ویرایش
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="increaseDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-0 pe-sm-4">
              <h4 class="c-grey mb-0">ورود کالا - افزایش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-0 pe-sm-4">
              <span class="pointer" @click="increaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ ورود:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedItem.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedItem.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت ورود:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedItem.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedItem.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم ورودی:</label>
              <v-text-field
                placeholder="حجم ورودی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مبدا:</label>
              <v-text-field
                placeholder="مبدا"
                outlined
                dense
                hide-details
                v-model="selectedItem.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <label class="primary--text font-weight-bold pt-2">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedItem.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="increaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="entrySubmit()"
            :disabled="busy || computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="decreaseDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-sm-4 pe-0 ps-sm-4 ps-0">
              <h4 class="c-grey mb-0">خروج کالا - کاهش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-sm-4 ps-sm-4 ps-0 pe-0">
              <span class="pointer" @click="decreaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ خروج:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedItem.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedItem.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت خروج:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedItem.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedItem.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم خروجی:</label>
              <v-text-field
                placeholder="حجم خروجی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مقصد:</label>
              <v-text-field
                placeholder="مقصد"
                outlined
                dense
                hide-details
                v-model="selectedItem.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <label class="primary--text font-weight-bold pt-2">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedItem.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="decreaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="exitSubmit()"
            :disabled="busy || computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editBarcodeDialog" width="400">
      <v-card>
        <v-card-title class="custom-input font-weight-bold" dense>
          ویرایش بارکد
        </v-card-title>
        <v-card-text class="pb-0 pt-3">
          <v-text-field
            rounded
            dense
            outlined
            v-model="selectedItem.barcode"
            label="بارکد"
            class="mt-3"
          >
          </v-text-field>
        </v-card-text>
        <div class="text-left pe-3 pb-3">
          <v-btn
            class="me-3 green-mainBtn white--text"
            @click="doEditBarcode(selectedItem.barcode)"
          >
            ثبت
          </v-btn>
          <v-btn
            @click="editBarcodeDialog = false"
            class="red-mainBtn white--text"
          >
            لغو
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      whichPage: 1,
      whichPage1: 1,
      whichPage2: 1,
      loaded1: false,
      tab: null,
      moment: moment,
      deviceType: "",
      allExchanges: [],
      filter: "",
      guide: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      products: [],
      selectedSort: "جدیدترین",
      selectedItem: {},
      newItem: {
        price: 0,
        buyPrice: 0,
        tags: [],
      },
      loading: false,
      loading2: false,
      loading3: false,
      expireProducts: [],
      busy: false,
      editDialog: false,
      increaseDialog: false,
      decreaseDialog: false,
      newProductDialog: false,
      calendarType: "startDate",
      startDate: "",
      endDate: "",
      type: Var.allTypes[3],
      types: ["همه", "رسید", "حواله"],
      typeFilter: "همه",
      sortOptions: [
        "جدیدترین",
        "کمترین موجودی",
        "بیشترین موجودی",
        "پرفروش‌ترین",
      ],
      weekDays: [
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنج‌شنبه",
        "جمعه",
      ],
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      daysOfWeek: [
        {
          text: "یکشنبه",
          value: 1,
        },
        {
          text: "دوشنبه",
          value: 2,
        },
        {
          text: "سه‌شنبه",
          value: 3,
        },
        {
          text: "چهارشنبه",
          value: 4,
        },
        {
          text: "پنجشنبه",
          value: 5,
        },
        {
          text: "جمعه",
          value: 6,
        },
        {
          text: "شنبه",
          value: 0,
        },
      ],
      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        // {key: "onlineName", label: "نام فروشگاهی"},
        { key: "sell", label: "تعداد فروش" },
        // {key: "totalVariants", label: "تعداد تنوع"},
        { key: "sum", label: "تعداد موجودی" },
        { key: "price", label: " قیمت " },
        { key: "barcode", label: "بارکد" },
        { key: "available", label: "وضعیت " },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "name", label: "نام محصول" },
        { field: "onlineName", label: "نام فروشگاهی" },
        { field: "sell", label: "تعداد فروش" },
        { field: "totalVariants", label: "تعداد تنوع" },
        { field: "variantsPriceRange", label: "بازه قیمتی " },
        { field: "variantsBarcodes", label: "لیست بارکدها " },
        { field: "variantsSum", label: "موجودی" },
      ],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "warehouseItemName", label: "نام محصول", sortable: true },
        { key: "amount", label: "مقدار", sortable: true },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ", sortable: true },
        { key: "note", label: "توضیحات" },
      ],
      expireFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول", sortable: true },
        { key: "price", label: "قیمت (تومان)", sortable: true },
        { key: "barcode", label: "بارکد" },
        { key: "expireDate", label: "تاریخ انقضا", sortable: true },
      ],
      dateTypes: [
        { value: "expired", text: "منقضی شده" },
        { value: "customDate", text: "تاریخ دلخواه" },
        {
          value: "nowNextWeek",
          text: "انقضا در هفته آتی",
        },
        {
          value: "nowNextMonth",
          text: "انقضا در ماه آتی",
        },
      ],
      chosenType: "expired",
      productsLoading: false,
      startExpireDate: "",
      endExpireDate: "",
      editBarcodeDialog: false,
      role: "",
      roleName: "",
      mainImage: [],
      myMainImage: new Object({
        uploadPercentage: 0,
      }),
      mainImageLoading: false,
      editMainImage: [],
      editMyMainImage: new Object({
        uploadPercentage: 0,
      }),
      editMainImageLoading: false,
      categories: [],
      brands: [],
      newTag: "",
      editNewTag: "",
      reactivity: false,
      galleryImage: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      editProductGallery: [],
      newFileNames: [],
    };
  },
  methods: {
    goToPage(item) {
      this.currentPage = Number(item);
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    getBrands() {
      this.loading = true;
      Axios.get(this.baseUrl + "/satrapp/shop/brands/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.brands = res.data;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading = false;
        });
    },
    openNewProduct() {
      this.newItem = { tags: [] };
      this.$router.push("addproduct");
      this.guide = false;
    },
    goToId(item) {
      let link = "/shop/editproduct/" + item.id;
      window.open(link, "_blank");
    },
    editBarcode(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.editBarcodeDialog = true;
    },
    // doEditBarcode() {
    //   this.busy = true;
    //   Axios.post(
    //     this.baseUrl + "/satrapp/warehouse/exchanges/entrance",
    //     {
    //       warehouseItemId: this.selectedItem.id,
    //       barcode: this.selectedItem.barcode,
    //     },
    //     {
    //       headers: {
    //         Authorization: "Bearer: " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //     .then((res) => {
    //       if (res.status == 201) {
    //         this.toast(res.data, "success");
    //         this.getProducts();
    //         // this.submit();
    //         this.busy = false;
    //       } else {
    //         const title = (
    //           <div>
    //             <h5>خطا </h5>
    //             <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
    //           </div>
    //         );
    //         this.toast(title, "error");
    //         this.busy = false;
    //       }
    //     })
    //     .catch((err) => {
    //      
    //       this.toast("خطا: " + err.response.data, "error");
    //       this.busy = false;
    //     });
    // },
    getProducts() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItems/getAllBySell",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.loading = false;
            this.loaded1 = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.loading = false;
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    // getProducts() {
    //   this.loading = true;
    //   Axios.post(
    //     this.baseUrl + "/satrapp/warehouse/warehouseItems/getAllBySellWithVariants",
    //     {},
    //     {
    //       headers: {
    //         Authorization: "Bearer: " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.products = res.data;
    //         this.loaded1 = true;
    //       } else {
    //         const title = (
    //           <div>
    //             <h5>خطا </h5>
    //             <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
    //           </div>
    //         );
    //         this.toast(title, "error");
    //       }
    //     })
    //     .catch((err) => {
    //       this.toast("خطا: " + err.response.data, "error");
    //     });
    // },
    getCategories() {
      Axios.get(this.baseUrl + "/satrapp/shop/categories/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.categories = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openDialog(item, type) {
      if (type == "edit") {
        this.galleryImage = [];
        this.myFile = new Object({
          uploadPercentage: 0,
        });
        Axios.post(
          this.baseUrl + "/satrapp/warehouse/warehouseItem/getInfo/",
          {
            warehouseItemId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.selectedItem = res.data;
             
              this.selectedItem.id = item.id;
              this.editDialog = true;
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            
            this.toast(err.response.data, "error");
          });
      } else if (type == "increase") {
        this.selectedItem = JSON.parse(JSON.stringify(item));
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.increaseDialog = true;
      } else if (type == "decrease") {
        this.selectedItem = JSON.parse(JSON.stringify(item));
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.decreaseDialog = true;
      }
    },
    getStartDate(value) {
      this.startDate = value;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    submit() {
      this.loading2 = true;
      let startDate = this.startDate + " 00:00";
      let finishDate = this.endDate + " 23:59";
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouse/exchanges",
        {
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.allExchanges.forEach((x) => {
              x.warehouseItemName ? x.warehouseItemName : "-";
            });
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading2 = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading2 = false;
        });
    },
    addItem() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/new",
        {
          warehouseTypeId: this.type.id,
          name: this.newItem.name ? this.newItem.name : "test",
          onlineName: this.newItem.onlineName
            ? this.newItem.onlineName
            : "test",
          amount: this.newItem.amount,
          identifierFa: this.newItem.name,
          identifierEn: this.newItem.name,
          description: this.newItem.description,
          technicalDescription: this.newItem.technicalDescription,
          material: this.newItem.material,
          coating: this.newItem.coating,
          dimensionStandard: this.newItem.dimensionStandard,
          diameter: this.newItem.diameter,
          length: this.newItem.length,
          place: this.newItem.place,
          suppliersList: this.newItem.suppliersList,
          expireDate: this.newItem.expireDate,
          measurementUnit: this.newItem.measurementUnit,
          alertRange: this.newItem.alertRange,
          crisisRange: this.newItem.crisisRange,
          price: this.newItem.price,
          buyPrice: this.newItem.buyPrice,
          barcode: this.newItem.barcode,
          categoryId: this.newItem.categoryId
            ? this.newItem.categoryId
            : undefined,
          pictureId: this.newItem.pictureId,
          special: this.newItem.special,
          tags: this.newItem.tags,
          onlineShopDescription: this.newItem.onlineShopDescription,
          brandId: this.newItem.brandId ? this.newItem.brandId : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getProducts();
            this.newProductDialog = false;
            this.newItem = { tags: [] };
            this.busy = false;
            this.loaded1 = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editItem() {
      this.busy = true;
      let myGalleryIds = this.selectedItem.gallery.map((x) => x.id);
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selectedItem.id,
          name: this.selectedItem.name,
          onlineName: this.selectedItem.onlineName,
          identifierFa: this.selectedItem.name,
          identifierEn: this.selectedItem.name,
          description: this.selectedItem.description,
          technicalDescription: this.selectedItem.technicalDescription,
          material: this.selectedItem.material,
          coating: this.selectedItem.coating,
          dimensionStandard: this.selectedItem.dimensionStandard,
          diameter: this.selectedItem.diameter,
          length: this.selectedItem.length,
          place: this.selectedItem.place,
          suppliersList: this.selectedItem.suppliersList,
          expireDate: this.selectedItem.expireDate,
          measurementUnit: this.selectedItem.measurementUnit,
          alertRange: this.selectedItem.alertRange,
          crisisRange: this.selectedItem.crisisRange,
          price: this.selectedItem.price,
          buyPrice: this.selectedItem.buyPrice,
          barcode: this.selectedItem.barcode,
          categoryId: this.selectedItem.categoryId
            ? this.selectedItem.categoryId
            : undefined,
          gallery: myGalleryIds,
          special: this.selectedItem.special,
          tags: this.selectedItem.tags,
          pictureId: this.selectedItem.pictureId
            ? this.selectedItem.pictureId
            : undefined,
          onlineShopDescription: this.selectedItem.onlineShopDescription,
          brandId: this.selectedItem.brandId
            ? this.selectedItem.brandId
            : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.getProducts();
            this.busy = false;
            this.loaded1 = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    entrySubmit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/entrance",
        {
          warehouseItemId: this.selectedItem.id,
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.increaseDialog = false;
            this.getProducts();
            // this.submit();
            this.busy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
         
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/exit",
        {
          warehouseItemId: this.selectedItem.id,
          // warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.decreaseDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    //expire tab
    expireTabFunc() {
      this.filter = "";
      this.currentPage = 1;
      this.perPage = 10;
      this.startExpireDate = "";
      this.endExpireDate = "";
      this.chosenType = "expired";
      this.getExpireProducts();
    },
    getExpireProducts() {
      this.productsLoading = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItems/getByExpireDate",
        {
          startDate:
            this.chosenType == "expired" ? "1400/01/01" : this.startExpireDate,
          endDate:
            this.chosenType == "expired"
              ? moment(new Date()).subtract(1, "days").format("jYYYY/jMM/jDD")
              : this.endExpireDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.expireProducts = res.data;
            this.productsLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.productsLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.productsLoading = false;
        });
    },
    chooseDateType(item) {
      this.chosenType = item.value;
      this.startExpireDate = "";
      this.endExpireDate = "";
      if (this.chosenType == "nowNextWeek") {
        this.startExpireDate = moment(new Date()).format("jYYYY/jMM/jDD");
        this.endExpireDate = moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.chosenType == "nowNextMonth") {
        this.startExpireDate = moment(new Date()).format("jYYYY/jMM/jDD");
        this.endExpireDate = moment(new Date())
          .add(30, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.chosenType == "customDate") {
        this.startExpireDate = moment(new Date())
          .subtract(7, "days")
          .format("jYYYY/jMM/jDD");
        this.endExpireDate = moment(new Date()).format("jYYYY/jMM/jDD");
      } else {
        this.getExpireProducts();
      }
    },
    // main image upload
    newProductMainImageUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.myMainImage.showProgress = true;
        this.myMainImage.variant = "info";
        this.myMainImage.uploadPercentage = 0;
        this.myMainImage.isUploaded = false;
        this.myMainImage.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.mainImageLoading = true;
        Axios.post(this.baseUrl + "/onlineShop/upload/draft", formData, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myMainImage.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        })
          .then((d) => {
            if (d.status == 200) {
              this.toast(d.data.message, "success");
              this.myMainImage.isUploaded = true;
              this.myMainImage.uploadPercentage = 100;
              this.myMainImage.striped = false;
              this.myMainImage.variant = "success";
              this.myMainImage.uploadButDisable = false;
              this.newItem.pictureId = d.data.id;
              this.newItem.pictureUrl = d.data.url;
              this.mainImageLoading = false;
            }
          })
          .catch((err) => {
          
            this.toast(err.response.data, "error");
            this.mainImageLoading = false;
          });
      }
    },
    // edit main image upload
    editProductMainImageUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.editMyMainImage.showProgress = true;
        this.editMyMainImage.variant = "info";
        this.editMyMainImage.uploadPercentage = 0;
        this.editMyMainImage.isUploaded = false;
        this.editMyMainImage.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.editMainImageLoading = true;
        Axios.post(
          this.baseUrl +
            "/onlineShop/upload/warehouseItem/" +
            this.selectedItem.id,
          formData,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
            onUploadProgress: ((progressEvent) => {
              this.editMyMainImage.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          }
        )
          .then((d) => {
            if (d.status == 200) {
              this.editMyMainImage.isUploaded = true;
              this.editMyMainImage.uploadPercentage = 100;
              this.editMyMainImage.striped = false;
              this.editMyMainImage.variant = "success";
              this.editMyMainImage.uploadButDisable = false;
              this.selectedItem.pictureId = d.data.id;
              this.selectedItem.pictureUrl = d.data.url;
              this.editMainImageLoading = false;
            }
          })
          .catch((err) => {
          
            this.toast(err.response.data, "error");
            this.editMainImageLoading = false;
          });
      }
    },
    // add image to product gallery
    editProductGalleryUpload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();

      formData.append(file.name, file);

      Axios.post(
        this.baseUrl +
          "/onlineShop/upload/warehouseItem/" +
          this.selectedItem.id,
        formData,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myFile.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        }
      )
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.selectedItem.gallery.push(d.data);
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    deleteFile(index) {
      this.selectedItem.gallery.splice(index, 1);
    },
    addNewTag(dataName) {
      if (dataName == "newItem") {
        if (!this.newItem.tags.includes(this.newTag.trim())) {
          this.newItem.tags.push(this.newTag.trim());
          this.newTag = "";
        } else {
          this.$toast("این تگ پیش از این افزوده شده است.", "error");
        }
      } else {
        if (!this.selectedItem.tags.includes(this.editNewTag.trim())) {
          this.selectedItem.tags.push(this.editNewTag.trim());
          this.editNewTag = "";
        } else {
          this.$toast("این تگ پیش از این افزوده شده است.", "error");
        }
      }
    },

    removeTag(dataName, index) {
      this[dataName].tags.splice(index, 1);
      this.reactivity = !this.reactivity;
    },
  },
  computed: {
    computedIndex() {
      let arr = [];
      let computedLength = this.computedItems.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedExchangesIndex() {
      let arr = [];
      let computedLength = this.computedExchanges.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedExpiredIndex() {
      let arr = [];
      let computedLength = this.computedExpiredProducts.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedItems() {
      let filtered;
      // this.currentPage=1;
      filtered = this.products.filter((x) =>
        x.name
          ? x.name.toLowerCase().includes(this.filter.toLowerCase())
          : "" || x.onlineName
          ? x.onlineName.toLowerCase().includes(this.filter.toLowerCase())
          : "" ||
            (x.barcode ? x.barcode.includes(this.filter) : "") ||
            (x.variantsPriceRange
              ? x.variantsPriceRange.includes(this.filter)
              : "") ||
            (x.variantsBarcodes
              ? x.variantsBarcodes.includes(this.filter)
              : "") ||
            String(x.price).includes(this.filter) ||
            String(x.sell).includes(this.filter) ||
            String(x.sum).includes(this.filter)
      );
      if (this.selectedSort == "جدیدترین") {
        return filtered;
      }
      if (this.selectedSort == "کمترین موجودی") {
        filtered.sort(function (a, b) {
          return a.sum - b.sum;
        });
      } else if (this.selectedSort == "بیشترین موجودی") {
        filtered.sort(function (a, b) {
          return b.sum - a.sum;
        });
      } else if (this.selectedSort == "پرفروش‌ترین") {
        filtered.sort(function (a, b) {
          return b.sell - a.sell;
        });
      }

      return filtered;
    },
    computedExchanges() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.allExchanges.filter(
          (x) =>
            x.warehouseItemName.includes(this.filter) ||
            String(x.amount).includes(this.filter) ||
            x.userName.includes(this.filter) ||
            x.date.includes(this.filter) ||
            x.note.includes(this.filter)
        );
      } else {
        filtered = this.allExchanges.filter(
          (x) =>
            x.warehouseItemName.includes(this.filter) &&
            x.type == this.typeFilter
        );
      }
      return filtered;
    },
    computedExpiredProducts() {
      let filtered;
      filtered = this.expireProducts.filter((x) =>
        x.name.includes(this.filter)
      );
      return filtered;
    },
    computedEditBtn() {
      if (
        this.selectedItem.name &&
        this.selectedItem.price &&
        this.selectedItem.buyPrice
      ) {
        return false;
      } else return true;
    },
    computedSubmitBtn() {
      if (
        this.selectedItem.date &&
        this.selectedItem.time &&
        this.selectedItem.number &&
        this.selectedItem.origin
      ) {
        return false;
      } else return true;
    },
    computedNewBtn() {
      if (
        this.newItem.name &&
        this.newItem.amount &&
        this.newItem.price &&
        this.newItem.buyPrice
      ) {
        return false;
      } else return true;
    },
  },
  mounted() {
    if (window.screen.width < 768) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }
    this.getCategories();
    this.getProducts();
    // this.getBrands();
    this.roleName = window.localStorage.getItem("role");
    // try {
    //   if (this.roles[this.roleName]) {
    //     this.role = this.roles[this.roleName];
    //   } else {
    //     this.role = "تعریف نشده";
    //   }
    // } catch (error) {
    //   this.role = "تعریف نشده";
    // }
    this.endDate = moment(new Date()).format("jYYYY/jMM/jDD");
    this.startDate = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
  },
};
</script>

<style lang="scss">
.products {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    @media only screen and (max-width: 768px) {
      padding: 11px 15px;
    }
    color: #656a81;
    width: fit-content;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;

      &:hover {
        background-color: #00b4d8;
      }
    }

    &:hover {
      background-color: #eee;
    }
  }

  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }

  .custom-input {
    .v-input__icon--append {
      padding-top: 3px !important;

      i {
        color: #6200ea !important;
        cursor: pointer;
      }
    }

    .date-input {
      fieldset {
        border: 1px solid #6200ea !important;
      }
    }

    .date-input.v-input--is-disabled {
      fieldset {
        border-color: rgba(118, 118, 118, 0.3) !important;
      }
    }
  }
}

.v-tabs:not(.v-tabs--vertical).v-tabs--right
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(
    .v-slide-group--has-affixes
  )
  .v-slide-group__next,
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(
    .v-slide-group--has-affixes
  )
  .v-slide-group__prev {
  display: none !important;
  visibility: hidden;
}

.product-dialog-card {
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;

  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }

    .v-input__icon--append {
      padding-top: 3px !important;

      i {
        color: #6200ea !important;
        cursor: pointer;
      }
    }
  }
}

.img-box {
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: #3c03923b !important;

    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3c03923b;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.file-input {
  fieldset {
    border-style: dashed !important;
  }
}

.files-box {
  border: 1px solid rgb(172, 172, 172);
  text-align: right;
  font-size: 14px;
  margin-top: 35px;
  padding: 10px;
  border-radius: 7px;
  position: relative;

  ul {
    li {
      text-decoration: none;
    }
  }

  .files-title {
    position: absolute;
    top: -9px;
    right: 20px;
    background-color: #fff;
    font-size: 14px;
    padding: 0 6px;
  }
}
</style>
